var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-window mt-3 mr-3 border bd-e4 px-3"},[_c('HeaderWindow',{attrs:{"title":_vm.test_item && _vm.test_item.test_result_name,"show_calll":true},on:{"onClose":_vm.onClose}}),_c('TestsTable',{attrs:{"documents":_vm.documents,"list_tests":_vm.person_tests},on:{"getTestsByDiseases":_vm.getPersonDiseasesByIdPersonTest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }